import React from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

interface OrdersTableProps {
  products: any[];
  loading: boolean;
  onEditOrder: (order: any) => void;
  currentPage: number;
  pageNumbers: any[];
  currentProducts: any[];
  handlePageChange: (e: any) => void;
  handleDeleteAcc: (order: any) => void;
}

const StoreTable: React.FC<OrdersTableProps> = ({
  products,
  loading,
  onEditOrder,
  currentPage,
  pageNumbers,
  handlePageChange,
  currentProducts,
  handleDeleteAcc,
}) => {
  const handleEditOrder = (order: any) => {
    onEditOrder(order);
  };

  

  return (
    <div className="flex flex-col text-black">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
          <div className="overflow-hidden  rounded-lg">
            <table className="min-w-full text-sm">
              <thead className="text-xs text-gray-700 
              dark:text-gray-400">
                <tr className="bg-gray-100 text-black text-[16px] h-[65px]">
                  <th scope="col" className="px-6 py-3">
                  Store Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                  Street Address
                  </th>

                  
                  {/* <th scope="col" className="px-6 py-3">
                    Description
                  </th> */}
                  <th scope="col" className="px-6 py-3">
                  City
                  </th>
                  <th scope="col" className="px-6 py-3">
                  State
                  </th>
                 
                  <th scope="col" className="px-6 py-3">
                  Location
                  </th>
                  
                  <th scope="col" className="px-6 py-3">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-blue">
                {loading ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  currentProducts.map((store) => (
                    <tr
                      key={store.id}
                      className="hover:bg-gray-100 transition duration-200 text-[#75A7AD]">
                      

                      <td className="border-b p-3 font-semibold text-black">
                      {store.storeName}
                      </td>

                      
                      <td className="border-b p-3 ">
                      {store.streetAddress}
                      </td>

                      <td className="border-b p-3 ">
                      {store.city}
                      </td>

                      <td className="border-b p-3 ">
                      {store.state}
                      </td>

                     

                      <td className="border-b p-3 ">
                      {store.locationType}
                      </td>

                      

                      {/* <td className="border-b p-3">{product.description}</td> */}
                      {/* <td className="border-b p-3">{product.ingredient}</td>
                      <td className="border-b p-3">{product.caption}</td>
                      <td className="border-b p-3">{product.price}</td> */}
                      <td className="border-b p-3">
                        <div className="flex items-center space-x-4">
                          <span
                            onClick={() => handleEditOrder(store)}
                            className="text-[#75A7AD] cursor-pointer hover:text-gray-800 flex items-center"
                            title="Edit Order">
                            <EditOutlined className="mr-1" />
                            Edit
                          </span>
                          <span
                            onClick={() => handleDeleteAcc(store.id)}
                            className="text-[#FF6347] cursor-pointer hover:text-gray-800 flex items-center"
                            title="Delete Order">
                            <DeleteOutlined className="mr-1" />
                            Delete
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 mt-[20px] justify-end">
        <section className=" inline-flex col row">
          <div className="flex">
            {currentPage > 1 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]">
                <BiChevronLeft size={30} className="text-black" />
              </button>
            )}

            {pageNumbers.map(
              (number, index) =>
                // Display only the relevant buttons for the current page
                currentPage <= index + 2 &&
                index + 1 <= currentPage + 2 && (
                  <div className="flex space-x-3" key={number}>
                    {<div></div>}
                    <button
                      className="rounded-full h-8 px-3 font-semibol text-white "
                      onClick={() => handlePageChange(number)}
                      style={{
                        backgroundColor:
                          number === currentPage ? "#75A7AD" : "white",
                        color: number === currentPage ? "white" : "black",
                      }}>
                      {number}
                    </button>
                  </div>
                )
            )}

            {currentPage < pageNumbers.length && (
              <button
                className="rounded-full h-8 px-1 font-semibol bg-white  ml-[10px]"
                onClick={() => handlePageChange(currentPage + 1)}>
                <BiChevronRight size={30} className="text-black " />
              </button>
            )}
          </div>
        </section>
        <section className=" flex space-x-8  p-2">
          <h5 className="font-bold text-black text-xs mr-[-20px]">
            Product per page
          </h5>
          <select
            id="role"
            className="mt-[-8px] w-[90px] py-2  block rounded-md focus:outline-none text-black text-sm bg-white"
            name="role"
            value={currentPage}
            onChange={(e) => handlePageChange(Number(e.target.value))}>
            {pageNumbers.map((option: number) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </section>
      </div>
    </div>
  );
};

export default StoreTable;

<div>
{/* <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className=" min-w-full py-2 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="w-full text-xs">
                  <thead>
                    <tr>
                      <th className="border-b p-2 bg-white text-left">
                        Store Name
                      </th>

                      <th className="border-b p-2 bg-white text-left">
                        Street Address
                      </th>

                      <th className="border-b p-2 bg-white text-left">City</th>

                      <th className="border-b p-2 bg-white text-left">State</th>

                      <th className="border-b p-2 bg-white text-left">
                        Phone Number
                      </th>

                      <th className="border-b p-2 bg-white text-left">
                        Status
                      </th>

                      <th className="border-b p-2 bg-white text-left">
                        Location
                      </th>

                      <th className="border-b p-2 bg-white text-left">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentStores.map((store, index) => (
                      <tr key={index}>
                        <td className="border-b p-2 bg-white text-left text-black font-bold">
                          {store.storeName}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.streetAddress}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.city}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.state}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.phoneNo}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.status}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          {store.locationType}
                        </td>

                        <td className="border-b p-2 bg-white text-left">
                          <span
                            onClick={() => handleEditAcc(store)}
                            className="cursor-pointer rounded flex items-center">
                            <FaEdit />
                            Edit
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}
</div>
